//输入的时间是'2022/3/11 12:00'这种格式
export const compareTime = (gettime,settime) => {
    var today = new Date()  //获取当前时间
    gettime = gettime.replace(/-/g, '/'); // 开始时间
    settime = settime.replace(/-/g, '/'); // 结束时间
    //转化成时间戳作比较
    var startTime = new Date(gettime) //自己的开始时间
    var endTime = new Date(settime) //自己的结束时间
    if (today.getTime() >= startTime.getTime() && today.getTime() <= endTime.getTime()) {
        //当前时间大于等于开始时间并且小于等于结束时间
        console.log('可以投票')
        return true
    } else {
        console.log('不可以投票')
        //当前时间小于我的时间
        return false
    }
}


// WEBPACK FOOTER //
// ./src/utils/compareTime.js